/* eslint-disable prettier/prettier */
import React from 'react';
import { Avatar ,Box, Typography, makeStyles} from '@material-ui/core';
 
const useStyles = makeStyles({
    component:{
        height: 40,
        display: 'flex',
        marginTop:'10px',
        cursor: 'pointer',
        '&:hover':{
            background:'#ffcd48',
            color:'white'
          }
    },
    container: {
        display: 'flex',
       paddingLeft:'10px'
    },
    own : {
      background:'#ffcd48',
      color:'white'
    }
})
 
const Conversation = ({user,own}) => {
 
  const classes = useStyles()
    return (
    <Box className={own ? (`${classes.component} ${classes.own}`) : (`${classes.component}`)} >
       <Box><Avatar/></Box>
       <Box className={classes.container}>
       <Typography>{user}</Typography>
       </Box>
       
    </Box>
  )
}
 
export default Conversation